<template>
  <div id="ebHansontableView">
    <HotTable class="eb-handsontable" ref="testRootView" root="testRootView" :settings="hotSettings"></HotTable>
  </div>
</template>
<script>
import HotTable from '@handsontable/vue';
export default {
  name: 'ebHansontable',
  props: {
    hotSettings: {
      required: true
    }
  },
  components: {
    HotTable
  },
  data: function() {
    return {};
  }
};
</script>
<style scoped lang="less">

</style>
